<div @fadeInOut class="tooltip" [ngStyle]="tooltipWidth() !== '' ? { 'max-width': tooltipWidth() } : {}">
  <span class="tooltip-text" [innerHTML]="tooltipText()"></span>
</div>
